module.exports = __webpack_public_path__ + "images/export.png";